import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SearchPosterProcessor } from '../../processors/index';
import { SimplifiedImage } from '../../components';
import Style from '../../styles/Search.module.scss';

const SearchPoster = ({
  account,
  breakpoint,
  isGrid,
  isPersonality,
  item,
  itemIndex,
  preventLazyLoad,
  searchProps,
}) => {
  const {
    link: route,
    onPosterClick,
    posterAltText,
    posterImage,
    badge,
    name,
  } = SearchPosterProcessor({
    account,
    isPersonality,
    item,
    searchProps,
  });
  const getCarouselPosterClasses = [];

  if (isGrid) {
    getCarouselPosterClasses.push(Style.gridPoster);
  }

  const posterImageProps = {
    badge,
    breakpoint,
    image: posterImage,
    isGrid,
    item,
    onPosterClick,
    posterAltText: posterAltText || name,
    preventLazyLoad,
    route,
    theme: Style,
  };

  return (
    <div className={classNames(getCarouselPosterClasses)} key={itemIndex}>
      <SimplifiedImage {...posterImageProps} />
    </div>
  );
};

export default SearchPoster;

SearchPoster.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  isGrid: PropTypes.bool,
  isPersonality: PropTypes.bool,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  preventLazyLoad: PropTypes.bool,
  searchProps: PropTypes.shape({}),
};
